<div class="container-fluid">
    <div class="col-md-12" *ngIf="isLoading">
        <app-busy [message]="message"></app-busy>
    </div>
    <div class="col-md-12" *ngIf="canload">
<!--             <div class="row">
                <div class="col-12" style="margin-top:10px;" *ngIf="dataCntrl.taskData.userComment">
                    <div class="row">
                        <div>
                            <h4><b>Comments</b></h4>
                        </div>
                    </div>
                    <div></div>
                    <div appHighlight [innerText]="dataCntrl.taskData.userComment"></div>
                </div>
            </div> -->
        <div class="col-md-12" *ngIf="show_assigned_user_message" >
                    <p style="color: red; text-align:center; padding: 5px;">This workflow activity is currently assigned to <strong>{{dataCntrl.taskData.userAssigned}}</strong>.</p>
        </div>
        <div class="col-md-12" *ngIf="ready_for_gazzette" >
            <p style="color: red; text-align:center; padding: 5px;">This workflow activity is currently waiting for Gazzetting. Click <a [routerLink]="['/list/gazettes']">here</a> to manage gazzettes.</p>
        </div>
        <br>
        <br>
        <div class="col-md-12">
            <label><strong>Select an action:</strong></label>
            <div class="btn-group-toggle" data-toggle="buttons">
                <label class="btn hd-btn-close btn-outline-primary" *ngIf="hasAction('Approve')">
                    <input type="radio" name="approve" id="approve" (click)="onActionChecked('Approve')"><p style="text-align: center; margin:auto !important; font-weight: 600;">Approve</p>
                </label>
                <label class="btn hd-btn-close btn-outline-primary" *ngIf="hasAction('Reject')">
                    <input type="radio" name="reject" id="reject" (click)="onActionChecked('Reject')"><p style="text-align: center; margin:auto !important; font-weight: 600;">Reject</p>
                </label>
                <label class="btn hd-btn-close btn-outline-primary" *ngIf="hasAction('Request More Info')">
                    <input type="radio" name="moreinfo" id="moreinfo" (click)="onActionChecked('Request More Info')"><p style="text-align: center; margin:auto !important; font-weight: 600;">Request More Info</p> 
                </label>
                <label class="btn hd-btn-close btn-outline-primary" *ngIf="hasAction('Send Back')">
                    <input type="radio" name="back" id="back" (click)="onActionChecked('Send Back')"><p style="text-align: center; margin:auto !important; font-weight: 600;">Send Back</p> 
                </label>
                <label class="btn hd-btn-close btn-outline-primary" *ngIf="hasAction('Send Forward')">
                    <input type="radio" name="forward" id="forward" (click)="onActionChecked('Send Forward')"><p style="text-align: center; margin:auto !important; font-weight: 600;">Send Forward</p> 
                </label>
            </div>
        </div>
        <br>
        <br>
        <div class="col-md-12">
            <div class="row">
<!--                 <div class="col-md-6">
                    <select class="form-control form-control-sm" style="width: 100%" (change)="actionChange()" [(ngModel)]="selectedAction">
                        <option [ngValue]="0">--- Please Select ---</option>
                        <option *ngFor="let action of actions" [ngValue]="action.name">{{action.name}}</option>
                    </select>
                </div> -->
                <div class="col-md-6">
                    <label><strong>Comments:</strong></label>
                    <select class="form-control form-control-sm" style="width: 100%" [disabled]="selectedAction == ''" (change)="onCommentSelected()" [(ngModel)]="selectedcomment">
                        <option value="0">--- Please Select ---</option>
                        <option value="Expired/Invalid SARS certificate">Expired/Invalid SARS certificate</option>
                        <option value="Wrong CIPC certificate">Wrong CIPC certificate</option>
                        <option value="Unclear attached Documents">Unclear attached Documents</option>
                        <option value="Invalid Bus Time Table">Invalid Bus Time Table</option>
                        <option value="Invalid Insurance/Passenger Routes">Invalid Insurance/Passenger Routes</option>
                        <option value="Invalid Ranking letter">Invalid Ranking letter</option>
                        <option value="Recommendation letter outdated">Recommendation letter outdated</option>
                        <option value="Route Description Not Clear">Route Description Not Clear</option>
                        <option value="Other">Other</option>
                    </select>
                    <p *ngIf="ismandatory==true" style="color: red; padding: 5px;">*Comments are mandatory for the selected action</p>
                </div>
                <div class="col-md-6" *ngIf="showCommentBox==true">
                    <label><strong>Please enter your comments below:</strong></label>
                    <textarea  rows="3" style="height:auto;" (keydown)="onCommentBlur()" [(ngModel)]="selectedcomment"></textarea>
                </div>                
            </div>                
        </div>
        <div class="col-md-12">
            <div class="row">
                <div class="col-sm-12" style="margin-top: 30px">
                    <button class="btn hd-btn" (click)="onProceed()" [disabled]="ismandatory==true && hascomment==false">Proceed</button>
                    <button class="btn hd-btn-close" (click)="onCancel()">Back</button>
                </div>
            </div>
        </div>
<!--         <div class="col-md-3">
            <div class="col-sm-12">
                <div *ngIf="external_approval">
                    <label><strong>External approver email: </strong></label>
                        <input type="text" name="ext_email" formControlName="EmailAddress" class="form-control input-sm form-control-sm" />
                </div>
            </div>
        </div> -->
    </div>
    <br>
    <br>
 <!--        <div bsModal #childModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name">
            <div class="modal-dialog modal-lg" role="document" style="margin-bottom: 0%; padding-bottom: 0%">
                <div class="modal-content"
                    style="border-style: solid;border-width: 1px;border-color: #1d3f94;padding: 0%;background-color: #ffffff;">
                    <div class="modal-body modal-lg" style="height: 200px">
                        <h5 style="text-align: center; margin-top: 12px; color: #1d3f94" [innerHTML]="modaltext">{{modaltext}}</h5>
                        <div>
                            <input type="text" #callbackfunc style="display: none;" [value]="callback"/>
                            <textarea id="userinput" style="height: 100%;" rows="5" cols="40" #comment></textarea>
                        </div>
                    </div>        
                    <div class="modal-footer" style="height: 65px; padding: 0%">
                        <div clas="row">
                            <div class="col-12" style="padding: 0%">
                                <button id="cancel" class="btn hd-btn-close" (click)="action(null, comment.value, callbackfunc.value)">Cancel</button>
                                <button id="nocomment" class="btn hd-btn" [disabled]="ismandatory" (click)="action(false,comment.value, callbackfunc.value)">No Comment </button>
                                <button id="proceed" class="btn hd-btn" (click)="action(true,comment.value, callbackfunc.value)">Proceed</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->

    <!-- BEGIN OTP POPUP-->

    <button data-toggle="modal" data-target="#addEdit" id="secretButton" style="display:none"></button>

<div class="modal fade form-group" id="addEdit" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" data-backdrop="false" style="background-color: rgba(0, 0, 0, 0.5);">
    <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <label class="text-center title">Enter verification code</label>
                <button type="button" class="close" data-dismiss="modal" id="closeButton" #closebutton aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
            </div>
            <div class="modal-body modal-xl">
                <form>

                    <div class="row test">
                        <div class="col-12 sp-fld">
                            <div class="text-center">
                                <p id="OtpMessage"></p>
                                <input class="form-control input-sm text-center" type="number" id="OTPCode" maxlength="6" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">

                        <button type="button" class="btn btn-primary btn-block mt-4 mb-4" (click)="verifyOtp()">Confirm</button>
                    </div>
                </form>
            </div>
        </div>

    </div>
</div>

    <!-- END OTP POPUP-->

</div>